module.exports = __webpack_public_path__ + "img/tu01.5a1ad901.png";